if (!customElements.get('image-with-text-slider-content')) {
  customElements.define(
    'image-with-text-slider-content',
    class ImageWithTextSliderContent extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.content = this.querySelector('.image-with-text-slider__content');
        // this.updateOverflowing(this.content);
        if (!this.content) return;

        this.updateOverflowing(this.content);
        this.observer = new ResizeObserver((entries) => {
          for (const entry of entries) {
            this.updateOverflowing(entry.target)
          }
        });
        this.observer.observe(this.content);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      updateOverflowing(el) {
        console.log({
          scrollHeight: el.scrollHeight,
          clientHeight: el.clientHeight,
          scrollWidth: el.scrollWidth,
          clientWidth: el.clientWidth,
        })
        this.classList.toggle(
          'image-with-text-slider__content-wrapper--overflowing',
          el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth
        );
      }
    }
  );
}
